export function toArray<T>(value: T | T[] | undefined | null): T[] {
    return (value && (Array.isArray(value) ? value : [value]).slice()) || [];
}
